import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { body } from "./drawer.module.scss";

const Body = ({ className, ...props }) => (
  <div className={classNames(body, "p-4", className)} {...props} />
);

Body.propTypes = {
  className: PropTypes.string
};

Body.defaultProps = {
  className: ""
};

export default Body;
